<template style="height: 100%">
  <aside class="menuInter">
    <div class="menuInter-body">
      <div class="has-text-right">
        <button class="close-button" aria-label="Cerrar" v-on:click="close">
          <i class="material-icons">close</i>
        </button>
      </div>
      <!-- Title -->
      <div
        v-if="config.seriesName"
        class="inter-title"
        :class="titleBg"
      >
        {{ config.seriesName }}
      </div>

      <!-- Info -->
      <div v-if="config.data" class="inter-sections">
        <!-- Definition -->
        <div v-if="config.dataG['def']" class="inter-card">
          <header class="inter-card__header" v-on:click="switchElement('def')">
            <span class="inter-card__icon">
              <i class="material-icons">book</i>
            </span>
            <span class="inter-card__title">Definición</span>
            <i class="material-icons inter-card__chevron">{{
              elements.def ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</i>
          </header>
          <transition name="fade">
            <div v-if="elements.def" class="inter-card__body">
              <p class="has-text-justified">{{ config.dataG["def"] }}</p>
            </div>
          </transition>
        </div>

        <!-- Interpretation -->
        <div v-if="config.data['inter']" class="inter-card">
          <header class="inter-card__header" v-on:click="switchElement('inter')">
            <span class="inter-card__icon">
              <i class="material-icons">import_contacts</i>
            </span>
            <span class="inter-card__title">Interpretación</span>
            <i class="material-icons inter-card__chevron">{{
              elements.inter ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</i>
          </header>
          <transition name="fade">
            <div v-if="elements.inter" class="inter-card__body">
              <p class="has-text-justified">{{ config.data["inter"] }}</p>
            </div>
          </transition>
        </div>

        <!-- Meta -->
        <div v-if="config.data['meta']" class="inter-card">
          <header class="inter-card__header" v-on:click="switchElement('meta')">
            <span class="inter-card__icon">
              <i class="material-icons">trending_up</i>
            </span>
            <span class="inter-card__title">Meta</span>
            <i class="material-icons inter-card__chevron">{{
              elements.meta ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</i>
          </header>
          <transition name="fade">
            <div v-if="elements.meta" class="inter-card__body">
              <p class="has-text-justified">{{ config.data["meta"] }}</p>
            </div>
          </transition>
        </div>

        <!-- Recomendaciones -->
        <div v-if="config.dataG['pract']" class="inter-card">
          <header class="inter-card__header" v-on:click="switchElement('pract')">
            <span class="inter-card__icon">
              <i class="material-icons">format_list_numbered</i>
            </span>
            <span class="inter-card__title">Recomendaciones</span>
            <i class="material-icons inter-card__chevron">{{
              elements.pract ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</i>
          </header>
          <transition name="fade">
            <div v-if="elements.pract" class="inter-card__body">
              <ul>
                <li
                  v-for="(a, k) in deleteEmptyElements(
                    config.dataG['pract'].split('-'),
                  )"
                  :key="k"
                >
                  <span v-if="a">{{ a }}</span>
                </li>
              </ul>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
import json from "../interpretaciones.json";
export default {
  data() {
    return {
      config: {},
      interpretations: json,
      elements: {
        def: true,
        inter: true,
        meta: false,
        pract: false,
      },
      titleBg: "rango0",
    };
  },
  props: {
    data: Object,
    type: Number,
  },
  methods: {
    getDataGraph() {
      const data = this.data;
      this.config = {
        group: data.config.series[0].data[data.dataPointIndex].group,
        subgroup: data.config.series[0].data[data.dataPointIndex].key,
        seriesName: data.config.series[0].data[data.dataPointIndex].x,
        dataValue: data.config.series[0].data[data.dataPointIndex].y,
        valueColor: data.config.colors[data.dataPointIndex],
        dataTarget: data.config.series[0].data[data.dataPointIndex].goals
          ? data.config.series[0].data[data.dataPointIndex].goals[0].value
          : 0,
        targetColor: data.config.series[0].data[data.dataPointIndex].goals
          ? data.config.series[0].data[data.dataPointIndex].goals[0].strokeColor
          : 0,
        data: null,
        dataG: null,
      };
      this.config.data = this.interpretations[this.config.group].dimensiones[
        this.config.subgroup
      ].rango[this.ranges(this.config.dataValue)];
      this.config.dataG = this.interpretations[this.config.group].dimensiones[
        this.config.subgroup
      ];
      this.titleBg = `rango${this.ranges(
        this.config.dataValue ? this.config.dataValue : 0,
      )}`;
      console.log(this.config);
    },
    getDataDetail() {
      const data = this.data;
      this.config = {
        group: data.group,
        subgroup: data.subGroup,
        seriesName: data.title,
        dataValue: data.p,
        valueColor: data.color,
        dataTarget: 0, // no tenemos target en el momento
        targetColor: 0, // no tenemos target en el momento
        data: null,
        dataG: null,
      };

      if (this.config.subgroup) {
        this.config.data = this.interpretations[this.config.group].dimensiones[
          this.config.subgroup
        ].rango[this.ranges(this.config.dataValue)];

        this.config.dataG = this.interpretations[this.config.group].dimensiones[
          this.config.subgroup
        ];
      } else {
        this.config.data = this.interpretations[this.config.group].rango[
          this.ranges(this.config.dataValue)
        ];
        this.config.dataG = this.interpretations[this.config.group];
      }

      this.titleBg = `rango${this.ranges(
        this.config.dataValue ? this.config.dataValue : 0,
      )}`;
    },
    switchElement(ele) {
      this.elements[ele] = !this.elements[ele];
    },
    close() {
      this.$emit("closeMenuInter");
    },
    deleteEmptyElements(array) {
      return array.filter(function(el) {
        return !!el.length;
      });
    },
    ranges(n) {
      let returned;

      if (n === 0) {
        returned = 6;
      } else if (isNaN(n)) {
        returned = 0;
      } else if (n >= 84) {
        returned = 1; // Sigamos así
      } else if (n >= 70) {
        returned = 2; // Vamos bien
      } else if (n >= 50) {
        returned = 3; // Estamos cerca
      } else if (n >= 30) {
        returned = 4; // Cuidado
      } else if (n >= 16) {
        returned = 5; // Necesita atención pronto
      } else {
        returned = 6; // Actuemos ya
      }

      return returned;
    },
  },
  created() {
    if (this.type === 0) this.getDataGraph();
    if (this.type === 1) this.getDataDetail();
  },
  watch: {
    data(nv, ov) {
      if (this.type === 0) this.getDataGraph();
      if (this.type === 1) this.getDataDetail();
    },
  },
};
</script>
<style lang="scss">
.menuInter {
  @media screen and (max-width: 768px) {
    width: 100%;
  }
  @media screen and (min-width: 1280px) {
    width: 30%;
  }
  height: 100%;
  position: fixed;
  background: white;
  z-index: 251;
  top: 0;
  right: 0;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 0 0 0 0 !important;
  /* Full-height left border (Bulma's lives on .message-body, which only
     spans the content height and looks cut off). */
  border-left: 2px solid #dbdbdb;
}

.border {
  border-radius: 10px;
}

.menuInter-body {
  padding: 1.5rem;
}

/* Slide the panel in/out from the right (matches the Definiciones panel). */
.slide-panel-enter-active,
.slide-panel-leave-active {
  transition: transform 0.3s ease;
}

.slide-panel-enter,
.slide-panel-leave-to {
  transform: translateX(100%);
}

/* Close button — matches the .nav-button style from MenuInterpretations. */
.close-button {
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #ffffff;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s ease;
}

.close-button:hover {
  background: #f9fafb;
  border-color: #d1d5db;
  color: #374151;
}

.close-button .material-icons {
  font-size: 20px;
}

/* Colored title pill (uses .rango* for its background) */
.inter-title {
  border-radius: 10px;
  padding: 14px 16px;
  margin: 8px 0 20px;
  text-align: center;
  text-transform: capitalize;
  font-size: 1.4rem;
  font-weight: 700;
}

/* Accordion list */
.inter-sections {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.inter-card {
  border: 1px solid #ececec;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.inter-card__header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  cursor: pointer;
  user-select: none;
  transition: background 0.15s ease;
}

.inter-card__header:hover {
  background: #faf9fc;
}

.inter-card__icon {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  border-radius: 8px;
  background: #f3eef9;
  color: #522687;
  display: flex;
  align-items: center;
  justify-content: center;
}

.inter-card__icon .material-icons {
  font-size: 18px;
}

.inter-card__title {
  flex: 1;
  font-size: 1rem;
  font-weight: 600;
  color: #363636;
}

.inter-card__chevron {
  color: #9b8bb4;
}

.inter-card__body {
  padding: 0 14px 12px;
  font-size: 0.9rem;
  line-height: 1.55;
  color: #4a4a4a;
}

.inter-card__body p {
  margin: 0;
}

.inter-card__body ul {
  list-style: disc !important;
  padding-left: 1.25em;
  margin: 0;
}
</style>
<style lang="scss">
.rango1 {
  background-color: var(--clima-1) !important;
  color: white !important;
}

.rango2 {
  background-color: var(--clima-2) !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango3 {
  background-color: var(--clima-3) !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango4 {
  background-color: var(--clima-4) !important; // f7d774a
  color: rgba(65, 64, 64, 0.91);
}

.rango5 {
  background-color: var(--clima-5) !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango6 {
  background-color: var(--clima-6) !important;
  color: rgba(65, 64, 64, 0.91);
}

.rango0 {
  background-color: #a5a5a5;
}
</style>



// WEBPACK FOOTER //
// src/components/climan/components/menuInterpretacion.vue